<script setup>
import { ref, computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';
import { useI18n } from 'vue-i18n';

import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import Button from 'dashboard/components-next/button/Button.vue';
import ContactsForm from 'dashboard/components-next/Contacts/ContactsForm/ContactsForm.vue';

const emit = defineEmits(['create']);

const { t } = useI18n();

const dialogRef = ref(null);
const contactsFormRef = ref(null);
const contact = ref(null);

const uiFlags = useMapGetter('contacts/getUIFlags');
const isCreatingContact = computed(() => uiFlags.value.isCreating);

const createNewContact = contactItem => {
  contact.value = contactItem;
};

const handleDialogConfirm = async () => {
  if (!contact.value) return;
  emit('create', contact.value);
};

const onSuccess = () => {
  contactsFormRef.value?.resetForm();
  dialogRef.value.close();
};

const closeDialog = () => {
  dialogRef.value.close();
};

defineExpose({ dialogRef, contactsFormRef, onSuccess });
</script>

<template>
  <Dialog
    ref="dialogRef"
    :title="t('CONTACTS_LAYOUT.CARD.EDIT_DETAILS_FORM.NEW_TITLE')"
    :subtitulo="t('CONTACTS_LAYOUT.HEADER.ACTIONS.CONTACT_CREATION.SUBTITULO')"
    icone="i-ph-user-plus"
    type="edit"
    width="3xl"
    overflow-y-auto
    @confirm="handleDialogConfirm"
  >
    <ContactsForm
      ref="contactsFormRef"
      is-new-contact
      sem-titulo
      @update="createNewContact"
    />
    <template #footer>
      <!-- Rodapé da nota: as duas ações à direita, desistir antes de salvar. -->
      <div class="cnc-rodape flex items-center justify-end gap-2">
        <Button
          :label="t('DIALOG.BUTTONS.CANCEL')"
          variant="faded"
          color="slate"
          type="reset"
          @click="closeDialog"
        />
        <Button
          type="submit"
          :label="
            t('CONTACTS_LAYOUT.HEADER.ACTIONS.CONTACT_CREATION.SAVE_CONTACT')
          "
          color="blue"
          :disabled="contactsFormRef?.isFormInvalid"
          :is-loading="isCreatingContact"
        />
      </div>
    </template>
  </Dialog>
</template>

<style scoped>
/* O rodapé gruda no fundo quando o formulário é mais alto que a tela (no
   celular os nove campos passam da dobra): "Salvar contato" fica sempre à
   vista. Sangra o \`p-6\` do diálogo e ganha o fio de cima do rodapé da nota. */
.cnc-rodape {
  position: sticky;
  bottom: calc(var(--esp-6) * -1);
  margin: 0 calc(var(--esp-6) * -1) calc(var(--esp-6) * -1);
  padding: var(--esp-4) var(--esp-6) var(--esp-6);
  border-top: 1px solid rgb(var(--slate-4));
  background: rgb(var(--solid-1));
}
</style>
